import type * as d3 from 'd3'

import type { ChartScales } from '@/features/bidding/types/bidLadder'

const OPPORTUNITY_COST_COLOR = '#8b5cf6' // Purple color for the opportunity cost line

/**
 * Renders a single opportunity cost line on the daily overview chart.
 * The value represents the daily total: sum of max(fcrd_up + fcrd_down, fcrn + energy_constant) for all hours.
 */
export function renderOpportunityCostLine(
  g: d3.Selection<SVGGElement, unknown, null, undefined>,
  scales: ChartScales,
  opportunityCost: number,
  isVisible: boolean,
) {
  const { yScale, chartWidth } = scales
  const opportunityGroup = g.append('g').attr('class', 'opportunity-cost-line')

  const yPosition = yScale(opportunityCost)

  // Render the line
  const line = opportunityGroup
    .append('line')
    .attr('class', 'opp-cost-line')
    .attr('x1', 0)
    .attr('x2', chartWidth)
    .attr('y1', yPosition)
    .attr('y2', yPosition)
    .attr('stroke', OPPORTUNITY_COST_COLOR)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '4,4')
    .attr('opacity', isVisible ? 0.8 : 0)

  // Render the price label
  opportunityGroup
    .append('text')
    .attr('x', chartWidth)
    .attr('y', yPosition - 4)
    .attr('text-anchor', 'end')
    .attr('font-size', '10px')
    .attr('font-weight', 500)
    .attr('fill', OPPORTUNITY_COST_COLOR)
    .attr('opacity', isVisible ? 1 : 0)
    .text(`€${opportunityCost.toFixed(1)}`)

  return line
}
